import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';
import type { GridSize } from '@mui/material/Grid';
import { ReceiveDeliveryFormConfig } from './receive-delivery-form-config';

export interface ReceiveDeliveryFormLayout {
  rows: {
    left: {
      field: keyof ReceiveDeliveryFormConfig;
      desktopGridSize: GridSize;
    };
    right: {
      field: keyof ReceiveDeliveryFormConfig;
      desktopGridSize: GridSize;
    };
  }[];
}

export function useReceiveDeliveryFormLayout(selectedDeliveryType: KnownDeliveryDtoDeliveryType) {
  const showDeliveringPartyOnLeft = [
    KnownDeliveryDtoDeliveryType.PeerToPeer,
    KnownDeliveryDtoDeliveryType.OutboundMail,
    KnownDeliveryDtoDeliveryType.OutboundDryCleaning
  ].includes(selectedDeliveryType);

  const partyLeftRightRatio: [GridSize, GridSize] =
    selectedDeliveryType === KnownDeliveryDtoDeliveryType.PeerToPeer ? [6, 6] : [8, 4];

  const formLayout: ReceiveDeliveryFormLayout = {
    rows: [
      {
        left: {
          field: 'deliveryType',
          desktopGridSize: 4
        },
        right: {
          field: 'carrierReference',
          desktopGridSize: 8
        }
      },
      {
        left: {
          field: showDeliveringPartyOnLeft ? 'deliveringParty' : 'receivingParty',
          desktopGridSize: partyLeftRightRatio[0]
        },
        right: {
          field: showDeliveringPartyOnLeft ? 'receivingParty' : 'deliveringParty',
          desktopGridSize: partyLeftRightRatio[1]
        }
      },
      {
        left: {
          field: 'hubID',
          desktopGridSize: 8
        },
        right: {
          field: 'deliveryContainerID',
          desktopGridSize: 4
        }
      }
    ]
  };

  return formLayout;
}
